module.exports = __webpack_public_path__ + "wave-3.3Po8CdLI.svg";